var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("toolbar", { attrs: { title: "Refer a Friend!" } }),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { column: "" } },
        [
          _c(
            "v-card",
            { staticClass: "py-3 pl-5" },
            [
              _c("h1", { staticClass: "display-2 pt-4" }, [
                _vm._v("\n          Refer a Friend!\n        ")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "headline py-2" }, [
                _vm._v(
                  "\n          Invite a friend you use " +
                    _vm._s(_vm.$t("site-title.brief")) +
                    ".\n          After they book their first load, you will both receive $50 account credit.\n        "
                )
              ]),
              _vm._v(" "),
              _c("h6", { staticClass: "subheading font-weight-bold" }, [
                _vm._v("Your referral link:")
              ]),
              _vm._v(" "),
              _c(
                "v-layout",
                [
                  _c("v-tooltip", { attrs: { top: "" } }, [
                    _c(
                      "p",
                      {
                        staticClass: "refer-link",
                        attrs: { slot: "activator" },
                        on: { click: _vm.copyLink },
                        slot: "activator"
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.referLink) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", [_vm._v("Click to copy")])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "h6",
                { staticClass: "mt-5 mb-2 subheading font-weight-bold" },
                [
                  _vm._v(
                    "\n          Or enter your friends email and we'll take care of the rest\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "form",
                {
                  attrs: { "data-vv-scope": "invite" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs7: "" } },
                        [
                          _c("v-text-field", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|email",
                                expression: "'required|email'"
                              }
                            ],
                            attrs: {
                              label: "Email address",
                              "prepend-icon": "mail",
                              "error-messages": _vm.errors.first(
                                "email",
                                "invite"
                              ),
                              "data-vv-as": "Email address",
                              "data-vv-name": "email",
                              "data-vv-scope": "invite"
                            },
                            model: {
                              value: _vm.email,
                              callback: function($$v) {
                                _vm.email = $$v
                              },
                              expression: "email"
                            }
                          }),
                          _vm._v(" "),
                          _c("v-text-field", {
                            attrs: {
                              label: "Message (optional)",
                              "prepend-icon": "chat",
                              "data-vv-as": "Message (optional)",
                              "data-vv-name": "message",
                              "data-vv-scope": "invite"
                            },
                            model: {
                              value: _vm.message,
                              callback: function($$v) {
                                _vm.message = $$v
                              },
                              expression: "message"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "primary",
                                loading: _vm.loadingBtn,
                                disabled: _vm.errors.any()
                              },
                              on: { click: _vm.sendEmail }
                            },
                            [_vm._v("Send")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1475c0c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1475c0c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/User/Refer.vue
// module id = null
// module chunks = 